import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { Demanda, TipoDemanda, updateDemandanteDemanda, updateRequisitanteDemanda } from '@app/api/demanda';
import { compareDates, compareNumberString, compareText } from '@app/helpers/comparators';
import { currencyFormat } from '@app/helpers/numbers';
import { Button, FilterWidget, OptionProps, Table } from '@digital/ui';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { Select } from 'antd';
const { Option } = Select;
import { Tooltip, Icon, Collapse } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { ISOStringFormat, formatarDataPadrao } from '@app/helpers/dateTimeFormats';
import {
  mountFormFilterDropDown,
  mountFormFilterDropDownServer,
  mountFormFilterDropDownServerWithSelectInfinity,
  mountFormSelectFilterDropDownServer,
} from '@app/utils/formFilterDropDown';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { SelectInfinity } from '@app/components';
interface Props {
  dados: Demanda[];
  updateUsuarioCompradorOrdemCompra(ordemCompraId: string, usuarioCompradorId: string): void;
  //onUpdate(filtros: FitroOrdemCompraPorStatusCodigo): void;
  fetchData: (data: any) => void;
  currentPage: number;
  pageSize: number;
  totalPage: number;
  totalItens: number;
  demandantes?: OptionProps[];
  requisitantes?: OptionProps[];
}

const STORAGE_KEY = 'visibleColumnsGridDemanda';

const defaultColumns = [
  'identificadorTexto',
  'objeto',
  'dataAberturaDemanda',
  'demandante',
  'tipo',
  'diretoria',
  'area',
  'departamento',
  'tipoAditivo',
  'numeroCt',
  'tipoServico',
  'expectativaValorFinal',
  'rc',
  'dataAberturaRc',
  'requisitante',
  'statusDemandaNome',
  'dataInicioStatusAtual',
  'responsavelGpcNome',
  'governancaAprovacao',
  'ddi',
  'oc',
  'statusOrdemCompraNome',
  'previsaoConclusaoContratacao',
  'dataInicioStatusAtualOC',
  'planejamentoControleGAS',
  'compradorNome',
];

const getInitialColumns = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return defaultColumns;
    }
  }
  return defaultColumns;
};

const GridDemandas = ({ dados, fetchData, currentPage, pageSize, totalPage, totalItens, demandantes, requisitantes }: Props) => {
  const [visibleColumns, setVisibleColumns] = useState<string[]>(getInitialColumns);

  const [, forceRender] = useState(false);
  const hasPermissaoGestor = hasPermissionPerfil([EGuidPerfilAcesso.AdministradorContratoMRN]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  
    const handleSelectDemandante = (record : any, demandanteId: string) => {

      updateDemandanteDemanda({
        Id: record.id,
        DemandanteId: demandanteId,
      }).then(data => {
        if (data) {
          record.demandanteId = demandanteId;
          forceRender(prev => !prev);
        }
      });
    };

    const handleSelectRequisitante = (record : any, requisitanteId: string) => {

      updateRequisitanteDemanda({
        Id: record.id,
        RequisitanteId: requisitanteId,
      }).then(data => {
        if (data) {
          record.requisitanteId = requisitanteId;
          forceRender(prev => !prev);
        }
      });
    };

  const columnOptions = [
    { label: 'Codigo', value: 'identificadorTexto' },
    { label: 'Objeto', value: 'objeto' },
    { label: 'Abertura Demanda', value: 'dataAberturaDemanda' },
    { label: 'Demandante', value: 'demandante' },
    { label: 'Tipo', value: 'tipo' },
    { label: 'Dir.', value: 'diretoria' },
    { label: 'Área', value: 'area' },
    { label: 'Depto', value: 'departamento' },
    { label: 'Tipo', value: 'tipo' },
    { label: 'Tipo de Aditivo', value: 'tipoAditivo' },
    { label: 'Numero Contrato/Pcs.', value: 'numeroCt' },
    { label: 'Tipo de Serviço', value: 'tipoServico' },
    { label: 'Valor Final', value: 'expectativaValorFinal' },
    { label: 'RC', value: 'rc' },
    { label: 'Abertura RC', value: 'dataAberturaRc' },
    { label: 'Requisitante', value: 'requisitante' },
    { label: 'Status da Demanda', value: 'statusDemandaNome' },
    { label: 'Início Status Demanda', value: 'dataInicioStatusAtual' },
    { label: 'Responsável Adm Contratos', value: 'responsavelGpcNome' },
    { label: 'Gov. Aprovação', value: 'governancaAprovacao' },
    { label: 'DDI', value: 'ddi' },
    { label: 'OC', value: 'oc' },
    { label: 'Status da OC', value: 'statusOrdemCompraNome' },
    { label: 'Previsão de Conclusão Contratação', value: 'previsaoConclusaoContratacao' },
    { label: 'Início Status OC', value: 'dataInicioStatusAtualOC' },
    { label: 'Planejamento e Controle GAS', value: 'planejamentoControleGAS' },
    { label: 'Comprador', value: 'compradorNome' },
  ];

  const columns = () => {
    let tempColumns: ColumnProps<any>[] = [];

    tempColumns.push({
      title: 'Demanda',
      children: [
        {
          title: 'Codigo',
          dataIndex: 'identificadorTexto',
          sorter: true,
          ...mountFormFilterDropDownServer('identificadorTexto', 'Pesquisar'),
          //sortOrder: 'descend',
        },
        {
          title: 'Objeto',
          dataIndex: 'objeto',
          render: (index, record) => {
            const text = record.objeto || '';
            const truncated = text.length > 6 ? text.slice(0, 6) + '...' : text;
            return <Tooltip title={text}>{truncated}</Tooltip>;
          },
        },
        {
          title: 'Abertura Demanda',
          dataIndex: 'dataAberturaDemanda',
          sorter: true,
          render: (text, record) => formatarDataPadrao(record.dataAberturaDemanda, true),
        },
        {
          title: 'Demandante',
          dataIndex: 'demandante',
          sorter: true,
          ...(hasPermissaoGestor
            ? {
              ...mountFormFilterDropDownServerWithSelectInfinity(
                'demandantes',
                'Pesquisar',
                demandantes || [],
                'demandanteId',
                handleSelectDemandante
              ),
            }
            : {
                ...mountFormFilterDropDownServer('demandante', 'Pesquisar'),
              }),
        },
        {
          title: 'Dir.',
          dataIndex: 'diretoria',
          sorter: true,
          ...mountFormFilterDropDownServer('diretoria', 'Pesquisar'),
        },
        {
          title: 'Área',
          dataIndex: 'area',
          sorter: true,
          ...mountFormFilterDropDownServer('area', 'Pesquisar'),
        },
        {
          title: 'Depto',
          dataIndex: 'departamento',
          sorter: true,
          ...mountFormFilterDropDownServer('departamento', 'Pesquisar'),
        },
        {
          title: 'Tipo',
          dataIndex: 'tipo',
          render: (text, record) => (record.tipo ? TipoDemanda[record.tipo] : ''),
          sorter: true,
          ...mountFormSelectFilterDropDownServer('tipo', 'Selecione o tipo', [
            { text: 'Nova Contratação', value: '1' },
            { text: 'Aditivo', value: '2' },
            { text: 'Acordo de Fornecimento', value: '3' },
            { text: 'Faturamento Direto', value: '4' },
            { text: 'Aditivo Faturamento Direto', value: '5' },
          ]),
        },
        {
          title: 'Tipo de Aditivo',
          dataIndex: 'tipoAditivo',
          render: (text, record, index) => (record.tipo == ETipoDemanda.Aditivo || record.tipo == ETipoDemanda.AditivoFaturamentoDireto ? record.tipoAditivo : 'Não se Aplica'),
          ...mountFormSelectFilterDropDownServer('tipoAditivo', 'Pesquisar', [
            { text: 'Prazo', value: 'prazo' },
            { text: 'Cláusula', value: 'clausula' },
            { text: 'Valor', value: 'valor' },
            { text: 'Remanejamento', value: 'remanejamento' },
            { text: 'N/A', value: 'na' },
          ]),
        },
        {
          title: 'Numero Contrato/Pcs.',
          dataIndex: 'numeroCt',
          render: (text, record, index) =>
            record.tipo == ETipoDemanda.Aditivo || record.tipo == ETipoDemanda.FaturamentoDireto || record.tipo == ETipoDemanda.AditivoFaturamentoDireto
              ? record.numeroCt
              : 'Não se Aplica',
          sorter: true,
          ...mountFormFilterDropDownServer('numeroCt', 'Pesquisar'),
        },
        {
          title: 'Tipo de Serviço',
          dataIndex: 'tipoServico',
          sorter: true,
          ...mountFormFilterDropDownServer('tipoServico', 'Pesquisar'),
        },
        {
          title: 'Valor Final',
          dataIndex: 'expectativaValorFinal',
          sorter: true,
          render: (text, record) => currencyFormat(record.expectativaValorFinal),
        },
        {
          title: 'RC',
          dataIndex: 'rc',
          sorter: true,
          ...mountFormFilterDropDownServer('rc', 'Pesquisar'),
        },
        {
          title: 'Abertura RC',
          dataIndex: 'dataAberturaRc',
          sorter: true,
          render: (text, record) => formatarDataPadrao(record.dataAberturaRc, true),
        },
        {
          title: 'Requisitante',
          dataIndex: 'requisitante',
          sorter: true,
          ...(hasPermissaoGestor ? {
              ...mountFormFilterDropDownServerWithSelectInfinity(
                'requisitantes',
                'Pesquisar',
                requisitantes || [],
                'requisitanteId',
                handleSelectRequisitante
              ),
            } : {
                ...mountFormFilterDropDownServer('requisitante', 'Pesquisar'),
              }),
        },
        {
          title: 'Status da Demanda',
          dataIndex: 'statusDemandaNome',
          sorter: true,
          ...mountFormSelectFilterDropDownServer('statusDemandaNome', 'Pesquisar', [
            { text: 'On Hold - Demandante', value: '58e96b08-d65c-4c47-8eaa-12eab8a0e995' },
            { text: 'Aguardando RC - Demandante - Modificação', value: '58c7579c-ac04-4aef-815f-135f12d88a86' },
            { text: 'Aguardando Análise Pré-Contratação', value: '6064dfee-2ba5-4d21-9a77-1d012ff232d5' },
            { text: 'Aguardando Geração OC', value: 'edd4b6f8-c8d6-4da7-ad5a-4ad8b6d8c18b' },
            { text: 'Aguardando Contratação – Suprimentos', value: '7a37ff09-a2c6-4ffd-87a4-4e523a72e83f' },
            { text: 'Aguardando Análise Controladoria - Reavaliação', value: 'cea3384e-0fe4-47da-a4ab-4f2dce89224f' },
            { text: 'Aguardando Confirmação do Questionário da Minuta', value: '016470e8-6ce0-4767-af9f-5019c812357f' },
            { text: 'Aguardando Análise Controladoria - Modificação', value: '361ffb9c-8240-4665-aedc-57ad85aee77f' },
            { text: 'Aguardando Análise Controladoria', value: '19dfe43e-da81-45d1-931b-5bb1ac9b7008' },
            { text: 'Aguardando RC - Reabertura', value: '4a121767-5413-427e-96e0-8a13b70ac346' },
            { text: 'Aguardando Gerente Geral', value: '50a2e4c9-97b2-4b0a-8d42-8bb7bff5c9b3' },
            { text: 'Aguardando Questionário da Minuta', value: '8d6ee846-ee09-4498-bdbd-9b164563631d' },
            { text: 'Concluído', value: '7f3daec6-5b1c-4b78-9cf9-9f7c666732fd' },
            { text: 'Aguardando Gestor Técnico', value: '782444ca-7abd-4434-9afa-a61810da0fe9' },
            { text: 'Aguardando Preenchimento - Demandante', value: '6866b85e-3a74-42ba-8e23-b60f355ae3f1' },
            {
              text: 'Aguardando Análise Controle Financeiro - Reavaliação',
              value: 'a9b1807a-d20c-48ae-aff4-b7426e12a3fa',
            },
            { text: 'Aguardando Geração Minuta', value: '6638f8cf-a1d0-4e66-83f3-beb6d4f014e1' },
            { text: 'Aguardando RC - Demandante', value: 'e471bdec-2da8-42d0-8af1-cb96282e02bb' },
            {
              text: 'Aguardando Análise Controle Financeiro - Modificação',
              value: '036d5aab-3571-4701-915c-ced776e30e8b',
            },
            { text: 'Aguardando RC - Demandante - Reavaliação', value: '458e0a73-264f-40fa-89a5-ced7d5a0544b' },
            { text: 'Cancelada', value: '405d32c0-75d0-43fb-833a-cf37bbc68c5b' },
            { text: 'Aguardando Gerente de Departamento', value: 'e9099b27-5a70-42c0-b5de-d9b35532f2d2' },
            { text: 'Aguardando Geração OC no Totvs', value: '59b55552-e0c3-404d-8fb7-e0e0f63d9509' },
            { text: 'Aguardando Análise Controle Financeiro', value: 'bf581db8-8d25-473a-9117-e75bb4bca984' },
            { text: 'Aguardando Geração OC no Totvs - Modificação', value: '8f5eb97b-c5c3-4285-be0e-e842a7f496ec' },
            { text: 'Aguardando Geração OC no Totvs - Reavaliação', value: '210d5c26-6899-47c7-8a8c-f57d1f8f2538' },
            {
              text: 'Aguardando Contratação – Suprimentos - Reavaliação',
              value: '5636b23a-c304-490c-9202-fae954a76cd5',
            },
          ]),
        },
        {
          title: 'Início Status Demanda',
          dataIndex: 'dataInicioStatusAtual',
          sorter: true,
          render: (text, record) => formatarDataPadrao(record.dataInicioStatusAtual, true),
        },
        {
          title: 'Responsável Adm Contratos',
          dataIndex: 'responsavelGpcNome',
          render: (text, record) => (record.tipo !== ETipoDemanda.AcordodeFornecimento ? text : 'Não se Aplica'),
          sorter: true,
          ...mountFormFilterDropDownServer('responsavelGpcNome', 'Pesquisar'),
        },
        {
          title: 'Gov. Aprovação',
          dataIndex: 'governancaAprovacao',
          sorter: true,
          render: (text, record) => (record.tipo !== ETipoDemanda.AcordodeFornecimento ? text : 'Não se Aplica'),
        },
        {
          title: 'DDI',
          dataIndex: 'ddi',
          render: (text, record) => (record.tipo !== ETipoDemanda.AcordodeFornecimento ? text : 'Não se Aplica'),
        },
      ],
    });

    const childrenColumnsOC: ColumnProps<any>[] = [
      {
        title: 'OC',
        dataIndex: 'oc',
        ...mountFormFilterDropDownServer('oc', 'Pesquisar'),
      },
      {
        title: 'Status da OC',
        dataIndex: 'statusOrdemCompraNome',
        sorter: true,
        ...mountFormFilterDropDownServer('statusOrdemCompraNome', 'Pesquisar'),
      },
      {
        title: 'Previsão de Conclusão Contratação',
        dataIndex: 'previsaoConclusaoContratacao',
        render: (text, record) => formatarDataPadrao(record.previsaoConclusaoContratacao, true),
      },
      {
        title: 'Início Status OC',
        dataIndex: 'dataInicioStatusAtualOC',
        render: (text, record) => formatarDataPadrao(record.dataInicioStatusAtualOC, true),
      },
      {
        title: 'Planejamento e Controle GAS',
        dataIndex: 'planejamentoControleGAS',
        ...mountFormFilterDropDownServer('planejamentoControleGAS', 'Pesquisar'),
      },
      {
        title: 'Comprador',
        dataIndex: 'compradorNome',
        render: (text, record) => (record.tipo !== ETipoDemanda.AcordodeFornecimento ? text : 'Não se Aplica'),
        sorter: true,
        ...mountFormFilterDropDownServer('compradorNome', 'Pesquisar'),
      },
    ];

    if (!hasPermission(['PRE_SUPRIMENTOS_DEMANDA_VISUALIZAR_COLUNA_COMPRADOR'])) {
      const idx = childrenColumnsOC.findIndex(e => e.title === 'Comprador');
      childrenColumnsOC.splice(idx, 1);
    }

    tempColumns.push({
      title: 'Processo de Contratação',
      children: childrenColumnsOC,
    });

    tempColumns.push({
      title: 'Ações',
      fixed: 'right',
      render: (text, record) => (
        <>
          <Tooltip title="Ir para Sumário">
            <Button
              id={`mrn-button-ir-para-demanda-${record.id}`}
              type="link"
              icon="ui-view_details"
              onClick={() => {
                //history.push(`/demanda/questionario/${record.id}`);
                const urlBase = window.location.origin;
                window.open(urlBase + `/demanda/questionario/${record.id}/sumario`);
              }}
              href="#"
            />
          </Tooltip>

          <Tooltip title="Ir para Demanda">
            <Button
              id={`mrn-button-ir-para-demanda-${record.id}`}
              type="link"
              icon="arrows-circled_right_2"
              onClick={() => {
                const urlBase = window.location.origin;
                window.open(`${urlBase}/demanda/questionario/${record.id}`);
              }}
              href="#"
            />
          </Tooltip>

          {record.ordemCompraId && (
            <Tooltip title="Ir para OC">
              <Button
                id={`mrn-button-ir-para-oc-${record.id}`}
                type="link"
                icon="files-add_file"
                onClick={() => {
                  const urlBase = window.location.origin;
                  window.open(`${urlBase}/ordemCompra/${record.ordemCompraId}/dadosGerais`);
                }}
                href="#"
              />
            </Tooltip>
          )}
        </>
      ),
    });

    return tempColumns;
  };

  const filteredColumns = useMemo(() => {
    const filterCol = (col: any) => {
      if (!col.children) {
        return col;
      }
      if (col.children) {
        const filteredChildren = col.children.filter(
          (child: any) =>
            !child.dataIndex ||
            visibleColumns.includes(Array.isArray(child.dataIndex) ? child.dataIndex.join('.') : child.dataIndex),
        );

        return filteredChildren.length > 0 ? { ...col, children: filteredChildren } : null;
      } else {
        return visibleColumns.includes(col.dataIndex) ? col : null;
      }
    };

    return columns().map(filterCol).filter(Boolean);
  }, [visibleColumns, demandantes, requisitantes]);

  return (
    <>
      <Collapse bordered={false}>
        <Collapse.Panel key="filtro" header={`Filtro de Colunas`}>
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%', marginBottom: 16 }}
            placeholder="Selecionar Colunas"
            value={visibleColumns}
            onChange={values => setVisibleColumns(values)}>
            {columnOptions.map(opt => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </Collapse.Panel>
      </Collapse>

      <Table
        key="mrn-table-demandas"
        id="mrn-table-demandas-em-andamento"
        columns={filteredColumns}
        dataSource={dados}
        pagination={{ pageSize: pageSize, total: totalItens }}
        onChange={(pagination: any, filters: any, sorter: any) => {
          fetchData(pagination, filters, sorter);
        }}
      />
    </>
  );
};
export default GridDemandas;
